@let view = data();

<ul class="cards">
  @for (card of view.cards; track card) {
    <li [class]="'card-item background-' + card.backgroundColor">
      <ui-headlines [data]="card.headlines"></ui-headlines>

      <ui-image [data]="card.image"></ui-image>

      <div [innerHtml]="card.content ?? ''" class="rte rte-themed" uiHtmlDataLink></div>
    </li>
  }
</ul>
